/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemPublicationWithRelations } from '../../models/item-publication-with-relations';

export interface AdminGetPublicationsListForItem$Params {
  id: string;
  inventoryId: string;
}

export function adminGetPublicationsListForItem(http: HttpClient, rootUrl: string, params: AdminGetPublicationsListForItem$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemPublicationWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetPublicationsListForItem.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ItemPublicationWithRelations>>;
    })
  );
}

adminGetPublicationsListForItem.PATH = '/admin/items/{id}/publications';
